module.exports = __webpack_public_path__ + "static/media/019.9fda8e6c.jpg";